module.exports = __webpack_public_path__ + "static/Screenshot (65)-0760d0917a118424efccaa04e83617e9.png";